import { FC, useMemo } from 'react';

import { beautifyEnum } from 'src/utils/utility';
import TransportMediumIcon from '../../card/TransportMediumIcon';
import { INotifDetailSectionProvidersProps } from './types';
import { NotificationDetailSection } from './Section';

export const NotificationDetailSectionProvider: FC<INotifDetailSectionProvidersProps> = ({ data, children, defaultExpanded = true }) => {
  const uniqueModalities = useMemo(() => {
    const allModalities =
      data?.invoiceGroups?.flatMap((invoiceGroup) => invoiceGroup.invoiceFileProcessingStatusList?.flatMap((item) => item.modalities || []) || []) || [];
    return [...new Set(allModalities)];
  }, [data?.invoiceGroups]);

  const modalityTitle = useMemo(() => {
    if (uniqueModalities.length === 0) return '';

    const formatModality = (modality: string) => {
      switch (modality) {
        case 'CT':
          return 'CONTROL TOWER';
        case 'COURIER':
          return 'COURIER';
        default:
          return modality;
      }
    };

    return uniqueModalities.map(formatModality).join(' & ');
  }, [uniqueModalities]);

  return (
    <NotificationDetailSection
      defaultExpanded={defaultExpanded}
      header={
        <div className='flex items-center'>
          <div className='flex-1'>
            <div className='flex-1 flex items-center gap-12'>
              <div className='flex items-center gap-4'>
                {uniqueModalities.map((modality) => (
                  <TransportMediumIcon key={modality} medium={modality} iconColor='#9F9F9F' />
                ))}
              </div>
              <div className='flex items-center gap-8'>
                <strong className='text-14 xl:text-16 font-bold'>{beautifyEnum(data?.serviceProviderCode)?.toUpperCase()}</strong>
                {modalityTitle && (
                  <>
                    <div className='w-4 h-4 bg-blue_grey-30 rounded-full' />
                    <strong className='text-12 xl:text-14 font-medium text-grey-40'>{modalityTitle}</strong>
                  </>
                )}
                <div className='w-4 h-4 bg-blue_grey-30 rounded-full' />
                <div className='text-12 xl:text-14 font-bold'>
                  {data?.invoiceGroups?.reduce((count, invoiceGroup) => count + (invoiceGroup.invoiceFileProcessingStatusList?.length || 0), 0) || 0} items
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    >
      {children}
    </NotificationDetailSection>
  );
};
